import { Grid, Typography } from "@mui/material";
import Textfield from "@/components/Textfield";
import { FormikProps } from "formik";
import { NewComerTicket, TicketFormData } from "@/types/tickets.types";

interface KeycloakRightFormProps {
  formik: FormikProps<TicketFormData<NewComerTicket>>;
  attributeFormikPrefix: string;
}

export const getKeycloakDefaultRightValues = () => ({
  environment: "",
  realm: "",
});

export const getKeycloakPlateformRightsDef = (prefix: string) => ({
  getDefaultRightValues: getKeycloakDefaultRightValues,
  getRequiredRightsComponent: (
    formik: FormikProps<TicketFormData<NewComerTicket>>,
  ) => (
    <KeycloakRequiredRightsForm
      formik={formik}
      attributeFormikPrefix={prefix}
    />
  ),
});

const KeycloakRequiredRightsForm = ({
  formik,
  attributeFormikPrefix,
}: KeycloakRightFormProps) => {
  return (
    <Grid container spacing={2} alignItems="center" key="keycloak">
      <Grid item xs={12}>
        <Typography variant="h4" color="cobalt.dodgerBlueIcon">
          Keycloak
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Textfield
          label="Environnement"
          formik={formik}
          name={`${attributeFormikPrefix}.environment`}
        />
      </Grid>
      <Grid item xs={6}>
        <Textfield
          label="Royaume"
          formik={formik}
          name={`${attributeFormikPrefix}.realm`}
        />
      </Grid>
    </Grid>
  );
};

export default KeycloakRequiredRightsForm;
